import { Space } from "antd";
import { InputSwitch } from "primereact/inputswitch";
import { Select } from "antd";
import { getFlagFromAlpha3, getFlagFromCountryName } from "../../utils/getFlags";
import getSymbolFromCurrency from "currency-symbol-map";

export type RiskRating = {
	riskID: number;
	riskLevel: string;
};

export type CountryDataType = {
	id: number;
	countryName: string;
	code: string;
	currencyCode: string;
	isDeleted: string;
	riskId?: number;
};

export const getColumns = (
	onDeleteToggle: (record: CountryDataType, value: boolean) => void,
	riskRatingOptions: RiskRating[],
	onRiskRatingChange: (record: CountryDataType, newRiskRatingId: number) => void
) => [
	{
		title: "Country / Currency",
		dataIndex: "countryName",
		key: "countryName",
		sorter: (a: CountryDataType, b: CountryDataType) => a.countryName.localeCompare(b.countryName),
		render: (text: string, record: CountryDataType) => (
			<span style={{ display: "flex", alignItems: "center", marginRight: "4px" }}>
				<img
					src={getFlagFromCountryName(text)}
					alt={text}
					style={{
						width: "15px",
						height: "15px",
						borderRadius: "50%",
						marginRight: "4px",
						objectFit: "cover"
					}}
				/>
				{text} / {getSymbolFromCurrency(record.currencyCode)} {record.currencyCode}
			</span>
		)
	},
	{
		title: "Country Code",
		dataIndex: "code",
		key: "code",
		sorter: (a: CountryDataType, b: CountryDataType) => a.code.localeCompare(b.code)
	},
	{
		title: "Risk Rating",
		key: "riskId",
		render: (_: any, record: CountryDataType) => (
			<Space size="middle">
				<Select
					value={record.riskId}
					style={{ width: 150 }}
					onChange={(value) => onRiskRatingChange(record, value)}
					options={riskRatingOptions?.map((risk) => ({
						value: risk.riskID,
						label: risk.riskLevel
					}))}
					placeholder="Select Risk Rating"
				/>
			</Space>
		)
	},
	{
		title: "Active",
		key: "active",
		render: (_: any, record: CountryDataType) => (
			<Space size="middle">
				<InputSwitch
					className="status-check activeinput"
					checked={record.isDeleted === "N"}
					onChange={(e) => onDeleteToggle(record, e.value)}
				/>
			</Space>
		)
	}
];
